import React, { useState } from 'react';
import { Helmet } from "react-helmet";


const ExamplePostsCollapsible = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const examples = [
    {
      title: "Standard Participation Post",
      content: "I've signed up for the upcoming Camp Apex coding challenge! Looking forward to testing my Apex skills in a timed competition environment. These challenges are a great way to sharpen technical abilities while connecting with the Salesforce community. #CampApex"
    },
    {
      title: "Professional Development Focus",
      content: "Just registered for Camp Apex's Apex coding competition! As someone looking to strengthen my Salesforce development credentials, I'm always seeking opportunities to practice under realistic conditions. Excited to see what challenges await and push my skills to the next level. #CampApex"
    },
    {
      title: "Community Engagement Post",
      content: "Ready to code! I've just signed up for the Camp Apex coding challenge happening soon! Who else is participating? Let's connect and share our experiences afterward! #CampApex"
    }
  ];
  
  return (
    <li className="mt-2 mb-3">
      <button
        className="text-blue-400 hover:text-blue-300 focus:outline-none flex items-center text-sm font-medium"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>See example LinkedIn posts</span>
        <svg
          className={`ml-1 w-4 h-4 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      
      {isOpen && (
        <div className="mt-2 pl-2 border-l-2 border-blue-500">
          {examples.map((example, index) => (
            <div key={index} className="mb-4">
              <h4 className="font-semibold text-blue-300 text-sm">{example.title}</h4>
              <p className="mt-1 text-sm italic bg-zinc-700 p-3 rounded">{example.content}</p>
            </div>
          ))}
        </div>
      )}
    </li>
  );
};

const CompetitionRules = () => {
  return (
    <div className="max-w-4xl mx-auto p-4 bg-zinc-900 text-white shadow-md rounded-lg pt-16">

<Helmet>
        <title>Salesforce Apex Coding Competition Rules & Prizes - Camp Apex</title>
        <meta name="description" content="Learn about the rules, $200 USD prizes, and eligibility requirements for Camp Apex's Salesforce Apex coding competitions. Get details on how to enter, submission guidelines, and more." />
        <meta name="keywords" content="salesforce competition rules, apex coding prizes, salesforce developer contest, camp apex rules, coding competition guidelines" />
        <link rel="canonical" href="https://www.campapex.org/competition-rules" />
        
        {/* Open Graph tags for social sharing */}
        <meta property="og:title" content="Salesforce Apex Coding Competition Rules & Prizes - Camp Apex" />
        <meta property="og:description" content="Learn about the rules, $200 USD prizes, and eligibility requirements for Camp Apex's Salesforce Apex coding competitions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.campapex.org/competition-rules" />
        
        {/* Twitter Card data */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Salesforce Apex Coding Competition Rules & Prizes - Camp Apex" />
        <meta name="twitter:description" content="Learn about the rules, $200 USD prizes, and eligibility requirements for Camp Apex's Salesforce Apex coding competitions." />
        
        {/* Structured data for rich results */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Salesforce Apex Coding Competition Rules & Prizes",
            "description": "Learn about the rules, $200 USD prizes, and eligibility requirements for Camp Apex's Salesforce Apex coding competitions.",
            "publisher": {
              "@type": "Organization",
              "name": "Camp Apex",
              "url": "https://www.campapex.org"
            },
            "mainEntity": {
              "@type": "ItemList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Prizes & Rewards",
                  "description": "Winners receive $200 USD towards their next Salesforce certification."
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "General Rules",
                  "description": "Open to all participants, time-limited competitions, solutions must be in Apex."
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Submission Guidelines",
                  "description": "All code submitted through the competition platform with automatic testing."
                }
              ]
            }
          })}
        </script>
      </Helmet>
      
      
      { <h1 className="text-3xl font-bold text-center mb-8 text-blue-400">An Apex Coding Competition for Salesforce Developers</h1> }
      
      <RulesSection 
        title="Prizes & Rewards" 
        rules={[
          <div>
            <p className="font-semibold mb-2">What's the prize?</p>
            <ul className="list-disc pl-6 mb-2">
              <li>Raffle winners will receive <strong>$50 USD</strong></li>
              <li>Funds will be distributed via the payment method agreed upon with winner(s)</li>
              <li>Make sure your email on the Camp Apex profile is accurate</li>
            </ul>
          </div>,
          <div>
            <p className="font-semibold mb-2">Raffle Entry</p>
            <p>There are three ways to enter our prize raffle:</p>
            <ol className="list-decimal pl-6 mb-2">
              <li>
                <strong>Share Your Certificate</strong>:
                <ul className="list-disc pl-6">
                  <li>Hit the blue "Generate Certificate" button on the previous page.</li>
                  <li>Share it on LinkedIn</li>
                  <li>Tag #CampApex in your post</li>
                  <ExamplePostsCollapsible />
                </ul>
              </li>
              <li>
                <strong>Complete the Contest</strong>:
                <ul className="list-disc pl-6">
                  <li>Simply finish the competition - you don't need to win or place. Just finish each challenge before time runs out.</li>
                </ul>
              </li>
              <li>
                <strong>Share your Competion Expereince</strong>:
                <ul className="list-disc pl-6">
                  <li>Post on LinkedIn about how you did, how you felt, or your overal expereince with the contest. Tag me so I don't miss adding you to the raffle.</li>
                </ul>
              </li>
            </ol>
          </div>
        ]} 
      />

<RulesSection 
        title="General Rules" 
        rules={[
          <span><strong>Eligibility</strong>: The competition is open to all participants regardless of experience level.</span>,
          <span><strong>Time Limit</strong>: Most contests are open for 24 hours from the announced start time.</span>,
          <span><strong>Programming Language</strong>: All solutions must be written in Apex code.</span>,
          <span><strong>Original Work</strong>: All code must be your original work.</span>,
        ]} 
      />
      
      <RulesSection 
        title="Submission Guidelines" 
        rules={[
          <span>All code must be submitted through the competition platform</span>,
          <span>Submissions are automatically tested by the platform - there is no manual judging</span>,
          <span>Raffle Winners will be announced once the competition concludes</span>
        ]} 
      />
      
    
      

      <div className="mt-8 text-center text-gray-300">
        <p>For any questions not covered here, please contact me at saman@campapex.org.</p>
        <p>This competition and webiste is not affiliated with Salesforce.com or it's entities.</p>
      </div>
    </div>
  );
};

const RulesSection = ({ title, rules }) => {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold mb-4 text-blue-400">{title}</h2>
      <ol className="list-decimal pl-6">
        {rules.map((rule, index) => (
          <li key={index} className="mb-3">{rule}</li>
        ))}
      </ol>
    </div>
  );
};


export default CompetitionRules;